module.exports = __webpack_public_path__ + "img/104080.768e72da.png";